/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Subscription_Rights_Quota_WeekInputs */

const fr_admin_subscription_rights_quota_week = /** @type {(inputs: Admin_Subscription_Rights_Quota_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Séances par semaine`)
};

/**

* @param {Admin_Subscription_Rights_Quota_WeekInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const admin_subscription_rights_quota_week = /** @type {((inputs?: Admin_Subscription_Rights_Quota_WeekInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Subscription_Rights_Quota_WeekInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_admin_subscription_rights_quota_week(inputs)
});